import { CircleAlertIcon } from "@lucide/icons";

import { H3, H5 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Popup } from "simplydo/react/ui/popup";

import {
  type InnointelCompany,
  parseProtectResults,
} from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  KeyFactLink,
} from "../Styles";

type CompanySanctionsProps = {
  protect?: NonNullable<NonNullable<InnointelCompany["creditsafe"]>["protect"]>;
};

const CompanySanctions = ({ protect }: CompanySanctionsProps) => {
  const alertsCount = protect?.alertsCount ?? 0;
  const results = parseProtectResults(protect?.results);

  if (alertsCount) {
    return (
      <InfoBoxWidget
        $noBox
        $sectioned
        style={{ minHeight: 520, overflow: "auto" }}
      >
        <InfoBoxWidgetTitleArea>
          <Icon icon={CircleAlertIcon} />
          <div>
            <H3>Sanctions & Alerts</H3>
            <span>{alertsCount} found</span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped $compact>
          {results.map((result) => (
            <Popup
              key={result.id ?? result.name}
              position="bottom right"
              on="click"
              trigger={
                <div style={{ display: "flex", flex: "0 calc(33% - 0.5rem)" }}>
                  <KeyFactLink
                    title={result.name ?? "Unknown"}
                    fact={result.comments[1] ?? result.comments[0] ?? ""}
                    style={{ flex: 1 }}
                  />
                </div>
              }
              content={
                <InfoBoxWidget
                  $noBox
                  style={{
                    maxHeight: "50vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <H5>Comments</H5>
                  {result.comments.map((comment) => (
                    <span
                      key={comment}
                      style={{ margin: "5px 0", maxWidth: 500 }}
                    >
                      {comment}
                    </span>
                  ))}
                  <H5>Sources</H5>
                  {result.sources.map((source) => (
                    <a
                      key={source}
                      href={source}
                      target="_blank"
                      rel="noreferrer"
                      style={{ margin: "5px 0", maxWidth: 500 }}
                    >
                      {source}
                    </a>
                  ))}
                </InfoBoxWidget>
              }
              wide="very"
            />
          ))}
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanySanctions;
